import request from '@/axios'

export function leadDetailsApi (payload, customer_id) {
   
  return request({
    url:`/leads/fetch_leads/${payload}/${customer_id}`,
    method:'GET'
  })
}

export function changeLeadStatus (payload) {
  return request({
    url: '/leads/change_leads_status',
    method: 'POST',
    data: payload
  })
}

export function dynamicField (payload) {
   
  return request({
    url:`/attributes/${payload}`,
    method:'GET'
  })
}
